import { Disease, FunctionalStatus } from "@domain/medical-condition/medical-condition";
import { Gender } from "@domain/patient/gender";
import { GlobalProgramStatus } from "@domain/program/program-status/program-status";

import { Dayjs } from "dayjs";

export interface PatientBase {
	id: string;
	analyticsId: string;
	functionalStatus?: FunctionalStatus;
	firstName: string;
	lastName: string;
}

export enum PatientStatus {
	Pending = "INVITED",
	Registered = "REGISTERED",
}

export interface PendingPatient extends PatientBase {
	status: PatientStatus.Pending;
	email?: string;
	activationCode: string;
	creationDate: Dayjs;
	link: string;
	expirationDays: number;
}

export interface Patient extends PatientBase {
	status: PatientStatus.Registered;
	disease?: Disease;
	email: string;
	creationDate: Dayjs;
	gender?: Gender;
	birthDate?: Dayjs;
	aspiration?: string;
}

export interface PatientList {
	pendingPatients: PendingPatient[];
	registeredPatients: RegisteredPatient[];
}

export interface RegisteredPatient extends PatientBase {
	lastCompletedSessionDate?: Dayjs;
	disease?: Disease;
	compliance: number | undefined;
	globalProgramStatus: GlobalProgramStatus;
}

export interface PatientGlobalComplianceListItem {
	id: string;
	globalCompliance?: number;
}

export type PatientNameListItem = Pick<PatientBase, "id" | "analyticsId" | "firstName" | "lastName">;

export function isPendingPatient(patient: Patient | PendingPatient): patient is PendingPatient {
	return patient.status === PatientStatus.Pending;
}
